import SuppliersRepository from "./SuppliersRepository";
import ExternalModuleRepository from "./ExternalModuleRepository";
import SupplierCategoryRepository from "./SupplierCategoryRepository";
import SupplierApiRepository from "./SupplierApiRepository";
import CategoriesRepository from "./CategoriesRepository";
import SubcategoriesRepository from "./SubcategoriesRepository";
import SupplierGoodsStockRepository from "./SupplierGoodsStockRepository";
import AccountRepository from "./AccountRepository";
import ContentPageRepository from "./ContentPageRepository";
import BannerRepository from "./BannerRepository";
import MenuCategory from "./MenuCategoryRepository";
import SubcategoryTagRepository from "./SubcategoryTagRepository";
const repositories = {
  suppliers: SuppliersRepository,
  externalModules: ExternalModuleRepository,
  supplierCategory: SupplierCategoryRepository,
  supplierApi: SupplierApiRepository,
  category: CategoriesRepository,
  subCategory: SubcategoriesRepository,
  supplierGoodsStock: SupplierGoodsStockRepository,
  accountRepository: AccountRepository,
  contentPage: ContentPageRepository,
  banner: BannerRepository,
  menuCategory: MenuCategory,
  subcategoryTag: SubcategoryTagRepository
};

export const RepositoryFactory = {
  get: (name) => repositories[name],
};
